<mat-sidenav-container class="publisher">
  <mat-sidenav mode="side" opened>
    <app-sidenav></app-sidenav>
  </mat-sidenav>
  <mat-sidenav-content class="publisher__content">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
